import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  LabelList,
  Cell,
} from "recharts";
import "./barchartbox.css";

const COLORS = [
  "#FF6B6B",
  "#F59E0B",
  "#10B981",
  "#3B82F6",
  "#8B5CF6",
  "#EC4899",
  "#F97316",
  "#14B8A6",
  "#6366F1",
  "#F43F5E",
];

const BarChartBox = ({ title, data }) => {
  return (
    <div
      style={{
        background: "linear-gradient(90deg, #ffb6c1, #ffb6c1)",
        padding: ".5vw",
        borderRadius: "1vw",
        border: ".4vw solid #ff92cf", // slightly darker pink border
        boxShadow: "0 1vw 2vw rgba(0,0,0,0.3)",
        color: "#000000",
        height:"21vh",
        marginTop:".01vh"
      }}
    >
      <h3
        style={{
          marginBottom: ".25vw",
          fontSize: "1vw",
          fontWeight: "bold",
          textShadow: "1px 1px 3px rgba(0,0,0,0.3)",
        }}
      >
        {title}
      </h3>
      <ResponsiveContainer width="90%" height={220}>
        <BarChart
          data={data}
          margin={{ top: 2, right: 10, left: 20, bottom: 40 }}
        >
          {/* Solid black grid lines */}
          <CartesianGrid stroke="" strokeDasharray="" />

          {/* X Axis */}
          <XAxis
            dataKey="name"
            angle={-35}
            textAnchor="end"
            interval={0}
            height={80}
            tick={{ fontSize: 10, fill: "#000", fontWeight: 700 }}
            axisLine={{ stroke: "#000000", strokeWidth: 1 }}
            tickLine={{ stroke: "#000000", strokeWidth: 3 }}
          />

          {/* Y Axis */}
          <YAxis
            tick={{ fontSize: 15, fill: "#000", fontWeight: 600 }}
            axisLine={{ stroke: "#000000", strokeWidth: 1 }}
            tickLine={{ stroke: "#000000", strokeWidth: 2 }}
            tickFormatter={(value) => `${(value / 1000).toFixed(0)}k`}
          />

          <Tooltip
            cursor={{ fill: "transparent" }}
            formatter={(value) => [
              value.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
              "Total Sale",
            ]}
            contentStyle={{
              backgroundColor: "#ffb6c1",
              borderRadius: "8px",
              border: "none",
              color: "#000000",
              fontWeight: "bold",
            }}
            labelStyle={{ color: "#000000", fontWeight: 5 }}
          />
          <Legend verticalAlign="top" height={36} wrapperStyle={{ color: "#000000" }} />

          {/* Bars */}
          <Bar dataKey="value" name="Total Sale" barSize={40} radius={[8, 8, 0, 0]}>
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
                fillOpacity={0.85}
              />
            ))}
            <LabelList
              dataKey="value"
              position="top"
              formatter={(value) =>
                value.toLocaleString(undefined, { minimumFractionDigits: 0 })
              }
              style={{ fontSize: 15, fill: "#000000", fontWeight: "600" }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarChartBox;
